import { createContext } from "react";

import type { Impulse } from "~/tools/impulse";
import { useRequiredContext } from "~/tools/use-required-context";

import type { TimeRange } from "../../../../../../app/state/view/timeline/TimeRange";

export interface MonitorStatusContextValue {
	timeRange: Impulse<TimeRange>;
}

const MonitorStatusContext = createContext<null | MonitorStatusContextValue>(null);

export const MonitorStatusContextProvider = MonitorStatusContext.Provider;

export const useMonitorStatusContext = (): MonitorStatusContextValue =>
	useRequiredContext(MonitorStatusContext, {
		providerName: "MonitorStatusProvider",
	});
